import { useCallback, useState } from 'react';

// Minimal column-filter helper used by list/table components.
// Returns `filters` keyed by column id, an `onFilterChange(id, value)` setter,
// and an `applyFilters(rows)` function that returns rows where every active
// filter substring-matches the corresponding row field (case-insensitive).
const useColumnFilters = (initial = {}) => {
  const [filters, setFilters] = useState(initial);

  const onFilterChange = useCallback((id, value) => {
    setFilters((prev) => ({ ...prev, [id]: value }));
  }, []);

  const applyFilters = useCallback(
    (rows) => {
      if (!Array.isArray(rows)) return [];
      const active = Object.entries(filters).filter(
        ([, v]) => v !== undefined && v !== null && String(v).length > 0,
      );
      if (active.length === 0) return rows;
      return rows.filter((row) =>
        active.every(([id, v]) => {
          const cell = row && row[id];
          if (cell === undefined || cell === null) return false;
          return String(cell).toLowerCase().includes(String(v).toLowerCase());
        }),
      );
    },
    [filters],
  );

  return { filters, onFilterChange, applyFilters, setFilters };
};

export default useColumnFilters;
